// components/Countdown.jsx
import React from 'react';

const RADIUS = 28;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export default function Countdown({ timeLeft, progress = 100 }) {
    const isWarning = timeLeft > 0 && timeLeft <= 5;
    const offset = CIRCUMFERENCE * (1 - progress / 100);

    return (
        <div className={`countdown-ring${isWarning ? ' countdown-warning' : ''}`}>
            <svg width="72" height="72" viewBox="0 0 72 72">
                <circle cx="36" cy="36" r={RADIUS} className="ring-bg" />
                <circle
                    cx="36" cy="36" r={RADIUS}
                    className="ring-fill"
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={offset}
                    style={{ transition: 'stroke-dashoffset 0.05s linear' }}
                />
            </svg>
            <span className="countdown-number">{timeLeft}</span>
        </div>
    );
}